<template>
  <div>
    <!-- Add -->
    <v-dialog width="1220" persistent v-model="dialog" scrollable>
      <v-card>
        <v-card-title style="font-size: 25px; height: 75px" class="pb-4">
          <v-icon style="color: #363636" class="mr-1"
            >mdi-circle-edit-outline</v-icon
          >
          {{ $t("editlessonlearn") }}
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="
              $emit('close'),
                (departmentSelected = []),
                (userSelected = []),
                $refs.form.reset(),
                DeletePDFfile()
            "
            color="#424242"
            style="
              border-radius: 8px !important;
              border: 1px solid rgba(66, 66, 66, 0.05);
            "
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>
        <v-card-text style="height: 800px">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row class="mt-5">
              <v-col cols="12" lg="12">
                <p style="font-size: 16px; color: #47484b">
                  {{ $t("createdateM") }}
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  {{ editLessonLearnData.createDate }}&nbsp;&nbsp;
                  {{ $t("By") }} {{ editLessonLearnData.createBy }}
                </p>
                <p
                  style="font-size: 16px; color: #47484b"
                  v-if="editLessonLearnData.updateBy != null"
                >
                  {{ $t("Last Update") }}
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  {{ editLessonLearnData.updateDate }}&nbsp;&nbsp;
                  {{ $t("By") }} {{ editLessonLearnData.updateBy }}
                </p>
              </v-col>
              <v-col>
                <v-row>
                  <v-col cols="12">
                    <label for="title" class="font-style"
                      >{{ $t("title") }}
                      <span style="color: red">*</span></label
                    >
                    <v-text-field
                      :rules="titleRules"
                      outlined
                      dense
                      hide-details="auto"
                      id="title"
                      v-model="editLessonLearnData.caseTitle"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <label for="description" class="font-style">{{
                      $t("description")
                    }}</label>
                    <v-text-field
                      outlined
                      dense
                      hide-details="auto"
                      id="description"
                      v-model="editLessonLearnData.caseDescription"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="6">
                    <label for="startDate" class="font-style">{{
                      $t("startdate")
                    }}</label>
                    <v-menu
                      v-model="startDateMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          class="rounded-lg"
                          v-bind="attrs"
                          v-on="on"
                          readonly
                          outlined
                          dense
                          hide-details="auto"
                          id="startDate"
                          prepend-inner-icon="mdi-calendar-blank-outline"
                          v-model="editStartDate"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        color="secondary"
                        :allowed-dates="allowedStartDates"
                        v-model="editStartDate"
                        @input="editstartdateDis()"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-progress-circular
                    v-if="loading"
                    indeterminate
                    class="loading-circle"
                    color="green"
                  ></v-progress-circular>
                  <v-col cols="12" xs="12" sm="12" md="6">
                    <label for="endDate" class="font-style">{{
                      $t("enddate")
                    }}</label>
                    <v-menu
                      v-model="endDateMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          class="rounded-lg"
                          v-bind="attrs"
                          v-on="on"
                          readonly
                          outlined
                          dense
                          hide-details="auto"
                          id="endDate"
                          prepend-inner-icon="mdi-calendar-blank-outline"
                          v-model="editEndDate"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        color="secondary"
                        :allowed-dates="allowedEndDates"
                        v-model="editEndDate"
                        @input="endDateMenu = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="6">
                <v-row>
                  <v-col cols="12" xs="12" sm="12" md="6" lg="7">
                    <p
                      class="text-left font-style"
                      :style="fileError ? { color: 'red' } : {}"
                    >
                      {{ $t("Image Cover") }}
                    </p>
                    <div class="drop">
                      <v-card
                        width="290"
                        height="215"
                        style="
                          border: 2px dashed #c0c0c0;
                          box-shadow: unset;
                          background: #f8f8f8 0% 0% no-repeat padding-box;
                        "
                        @click="$refs.file.click()"
                        @dragover.prevent
                        @dragenter.prevent
                        @drop.prevent="dropImg($event)"
                      >
                        <v-img
                          :src="editLessonLearnData.caseImage"
                         
                          @mouseover="
                            editLessonLearnData.caseImage
                              ? (showEditImgTool = true)
                              : (showEditImgTool = false)
                          "
                          @mouseleave="
                            editLessonLearnData.caseImage
                              ? (showEditImgTool = false)
                              : (showEditImgTool = false)
                          "
                          :style="
                            fileError ? { border: '1px solid #FA5252' } : {}
                          "
                          width="240"
                          height="167"
                          style="border-radius: 8px !important"
                          class="mx-auto center mt-4"
                          v-if="editLessonLearnData.caseImage != null"
                        >
                          <v-card-title
                            v-if="showEditImgTool"
                            style="left: 15%; top: 15%; position: absolute"
                          >
                            <v-list
                              class="d-flex flex-column align-start"
                              style="padding: 0; border-radius: 8px"
                            >
                              <v-list-item class="list-item-padding">
                                <v-btn
                                  color="#424242"
                                  style="font-size: 14px; width: 100px"
                                  text
                                  class="text-capitalize"
                                  @click="previewimg = true"
                                  @click.stop="LessonLearnData.file = null"
                                >
                                  <v-icon left>mdi-eye-outline</v-icon>
                                  {{ $t("preview") }}
                                </v-btn>
                              </v-list-item>

                              <v-list-item class="list-item-padding">
                                <v-btn
                                  color="error"
                                  style="font-size: 14px; width: 100px"
                                  text
                                  class="text-capitalize"
                                  @click.stop="
                                    editLessonLearnData.caseImage = null
                                  "
                                >
                                  <v-icon left>mdi-delete-outline</v-icon>
                                  {{ $t("delete") }}
                                </v-btn>
                              </v-list-item>
                            </v-list>
                          </v-card-title>
                        </v-img>
                        <v-img
                          v-if="editLessonLearnData.caseImage == null"
                          src="@/assets/image_loader.png"
                          width="64"
                          height="52"
                          class="mx-auto center"
                          style="margin-top: 2.5rem"
                      
                        ></v-img>
                        <input
                          type="file"
                          class="d-none"
                          ref="file"
                          accept="image/*"
                          @change="uploadImg($event, 1)"
                        />
                        <p
                          v-show="editLessonLearnData.caseImage == null"
                          class="text-center mt-3"
                          style="
                            color: #424242;
                            font-size: 14px;
                            opacity: 0.6;
                            margin-bottom: 0;
                          "
                        >
                          {{ $t("DragDropfile") }}
                        </p>
                        <p
                          v-show="editLessonLearnData.caseImage == null"
                          class="text-center"
                          style="color: #424242; font-size: 14px; opacity: 0.6"
                        >
                          {{ $t("OrBrowseFile") }} JPG"
                        </p>
                      </v-card>
                    </div>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="6" lg="5">
                    <v-row>
                      <v-btn
                        color="#A6CC39"
                        style="
                          margin-top: 3rem;
                          float: left;
                          border-radius: 8px;
                          height: 40px;
                        "
                        class="text-capitalize white--text btn_hover_effect"
                        @click="$refs.file.click()"
                      >
                        <v-icon class="mr-1">mdi-plus-box-outline</v-icon>
                        {{ $t("Add Cover") }}
                      </v-btn>
                      <p
                        class="mt-3 pr-3"
                        style="color: #777777; font-size: 12px"
                      >
                        {{ $t("RecommendFormatPNG") }}
                      </p>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" lg="12">
                <label for="wordContent" class="font-style">
                  {{ $t("wordcontent") }}
                  <span style="color: red">*</span>
                </label>
                <v-textarea
                  outlined
                  :rules="wordContentRules"
                  no-resize
                  id="wordContent"
                  v-model="editLessonLearnData.wordContent"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <label for="link" class="font-style">{{ $t("link") }}</label>
                <v-text-field
                  outlined
                  dense
                  hide-details="auto"
                  id="link"
                  @input="checkLinkType"
                  v-model="editLessonLearnData.link"
                ></v-text-field>
                <span v-if="notLink" style="color: red; font-size: 13px">{{
                  $t("invalidUrlLink")
                }}</span>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <input
                  type="file"
                  accept="application/pdf"
                  class="d-none"
                  ref="pdffile"
                  @change="getpdfFile($event)"
                />
                <v-btn
                  :disabled="LessonLearnData.PDFButtonDisable"
                  color="#A6CC39"
                  @click="($refs.pdffile.value = null), $refs.pdffile.click()"
                  style="font-size: 13px; border-radius: 8px"
                  class="text-capitalize white--text reset-btn"
                >
                  <v-icon class="mr-2" style="font-size: 18px"
                    >mdi-folder-search-outline</v-icon
                  >
                  {{ $t("Browse File") }}
                </v-btn>
                <label
                  for="browsefiles"
                  style="margin-left: 10px"
                  v-if="
                    editLessonLearnData.pdFfilename != '' ||
                    editLessonLearnData.pdFfilename == null
                  "
                  class="font-style"
                  :change="checkdisabledata(editLessonLearnData.pdFfilename)"
                  >{{ editLessonLearnData.pdFfilename }}</label
                >
                <v-icon
                  @click="DeletePDFfile"
                  width="20"
                  height="20"
                  color="error"
                  v-if="LessonLearnData.PDFButtonDisable"
                  style="cursor: pointer; border: 1px"
                  >mdi-delete</v-icon
                >
                <p class="mt-3 pr-3" style="color: #777777; font-size: 12px">
                  {{ $t("RecommendFormatPDF") }}
                </p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="3">
                <v-checkbox
                  v-model="editLessonLearnData.allView"
                  :label="$t('allusercanview')"
                ></v-checkbox>
              </v-col>
              <v-spacer></v-spacer>
              <v-col>
                <v-btn
                  color="#a6cc39"
                  style="
                    font-size: 16px;
                    margin-top: 13px;
                    float: right;
                    border-radius: 8px;
                  "
                  class="text-capitalize white--text"
                  @click="(listDialog = true), openList()"
                  >{{ $t("requesteduser") }}</v-btn
                >
              </v-col>
            </v-row>
            <!-- {{editLessonLearnData.permissionData}} -->
            <v-row>
              <v-col>
                <v-data-table
                  :items="selectedList"
                  class="lesson-table"
                  loading-text="Loading... Please wait"
                  :headers="selectedListUserHeader"
                  hide-default-footer
                  @page-count="pageCount = $event"
                  :page.sync="page"
                  :no-data-text="$t('nodata')"
                >
                  <template v-slot:item.request="{ item }">
                    <v-row justify="center">
                      <v-checkbox
                        color="#9FC437"
                        v-model="item.request"
                      ></v-checkbox>
                    </v-row>
                  </template>
                  <template v-slot:item.perDay="{ item }">
                    <div v-if="item.request">
                      <v-menu
                        ref="menu"
                        v-model="item.menu"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="auto"
                        :close-on-content-click="false"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-on="on"
                            v-bind="attrs"
                            v-model="item.dateStatus"
                            append-icon="mdi-calendar-month"
                            outlined
                            dense
                            readonly
                            hide-details="auto"
                            :rules="[rulesDate.required]"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="item.perDay"
                          :allowed-dates="allowedPerday"
                          no-title
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="item.menu = false"
                            >Cancel</v-btn
                          >
                          <v-btn
                            text
                            color="primary"
                            @click="
                              $refs.menu.save(item.perDay),
                                (item.menu = false),
                                (item.dateStatus = checkOrgianlStatus(
                                  item.perDay
                                ))
                            "
                            >OK</v-btn
                          >
                        </v-date-picker>
                      </v-menu>
                    </div>
                  </template>
                  <template v-slot:item.index="{ item }">
                    <v-btn
                      color="error"
                      text
                      style="font-size: 16px; color: #fa5252 !important"
                      class="text-capitalize"
                      @click="DeletefromUser(item)"
                    >
                      <v-icon>mdi-delete-outline</v-icon>
                      {{ $t("remove") }}
                    </v-btn>
                  </template>
                  <template v-slot:no-data>
                    <p style="font-size: 16px">{{ $t("nodata") }}</p>
                  </template>
                </v-data-table>
                <v-row justify="end">
                  <div class="ma-5 d-flex">
                    <v-pagination
                      circle
                      v-model="page"
                      class="pagination"
                      :length="pageCount"
                    ></v-pagination>
                  </div>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-card class="customcardnoti">
                <v-card-subtitle
                  style="color: #424242; font-size: 18px; font-weight: bold"
                >
                  {{ $t("sendnotifications") }}
                </v-card-subtitle>
              </v-card>
            </v-row>
            <v-row class="ml-6 mr-15 mt-7" rows="12" sm="12" md="12" lg="12">
              <div class="ml-5" >
                <v-card width="205px"
                        height="35px"
                        style="
                          border: 1px dashed #c0c0c0;
                          box-shadow: unset;
                          border-radius: 4px;
                          display: flex;
                          align-items: center;
                          justify-content: start;
                        "
                        >
                <v-checkbox
                  class="pb-5 ml-3"
                  :label="$t('inbox')"
                  color="#a6cc39"
                  v-model="inbox_flag"
                  hide-details
                ></v-checkbox
              ></v-card>
              </div>
              <div class="ml-10"
                >
                <v-card width="205px"
                        height="35px"
                        style="
                          border: 1px dashed #c0c0c0;
                          box-shadow: unset;
                          border-radius: 4px;
                          display: flex;
                          align-items: center;
                          justify-content: start;
                        "
                        >
                <v-checkbox
                class="pb-5 ml-3"
                  color="#a6cc39"
                  :label="$t('pushnotification')"
                  v-model="pushNoti_flag"
                  hide-details
                ></v-checkbox
              ></v-card>
            </div>
              
              <div class="ml-10" >
                <v-card width="205px"
                        height="35px"
                        style="
                          border: 1px dashed #c0c0c0;
                          box-shadow: unset;
                          border-radius: 4px;
                          display: flex;
                          align-items: center;
                          justify-content: start;
                        "
                        >
                <v-checkbox
                 class="pb-5 ml-3"
                  color="#a6cc39"
                  :label="$t('line')"
                 v-model="line_flag"
                  hide-details
                ></v-checkbox>
              </v-card>
            </div>
              <div
              class="d-flex justify-start ml-10" 
              >
                <v-card
                  width="300px"
                  height="35px"
                  style="
                    border: 1.5px dashed #c0c0c0;
                    box-shadow: unset;
                    border-radius: 4px;
                    display: flex;
                    align-items: center;
                    justify-content: start;
                  "
                >
                <v-row
                    class="d-flex justify-start align-center"
                    no-gutters
                  >
                    <v-col class="d-flex justify-start align-center" cols="5">
                      <v-checkbox
                        class="pb-5 ml-3"
                        color="#a6cc39"
                        :label="$t('email')"
                        v-model="email_flag"
                        @change="handleCheckboxChange"
                        hide-details
                      ></v-checkbox>
                    </v-col>
                    <template>
                      <v-col class="d-flex justify-start align-center">
                        <v-row class="d-flex justify-start align-center ml-3">
                          <v-radio-group v-model="selectedRadio" class="radio-group" :disable="!email_flag">
                            <v-row rows="12" class="radiobutton">
                              <div class="radio-wrapper">
                             
                             <div v-if="!email_flag" class="radio-placeholder"></div>
                            
                             <v-radio
                               v-else
                               value="thai"
                               class="radio-button"
                             ></v-radio>
                           </div>
                           <v-img
                              src="@/assets/thailandflag.svg"
                              width="35"
                              height="22"
                              class="ml-2"
                            ></v-img>
                            <div class="radio-wrapper ml-2">
                             
                             <div v-if="!email_flag" class="radio-placeholder"> </div>
                            <v-radio
                            v-else
                            class=" radio-button"
                             value="eng"
                            
                              >
                            </v-radio>
                            </div>
                            <v-img
                              src="@/assets/ukflag.svg"
                              width="35"
                              height="22"
                              class="ml-2"
                            ></v-img>
                            </v-row>
                            
                          </v-radio-group>
                         
                        </v-row>
                      </v-col>
                    </template>
                  </v-row>
                </v-card>
              </div>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions class="mt-3 pb-4">
          <v-spacer></v-spacer>
          <v-btn
            class="text-capitalize btnfont-style"
            text
            outlined
            @click="
              $emit('close'),
                (departmentSelected = []),
                (userSelected = []),
                $refs.form.reset(),
                DeletePDFfile()
            "
            >{{ $t("cancel") }}</v-btn
          >
          <v-btn
            class="text-capitalize btnfont-style"
            color="secondary"
            @click="submit()"
            >{{ $t("update") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- preview image -->
    <v-dialog
      v-model="previewimg"
      persistent
      width="1000px"
      height="800px"
      overflow="hidden"
      content-class="elevation-0 preview_class"
    >
      <v-card overflow="hidden" color="transparent">
        <v-card-title style="padding-right: 0 !important">
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="previewimg = false"
            color="#FFFFFF"
            style="border-radius: 8px !important; border: 1px solid #ffffff30"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-img
          width="900px"
          height="500px"
          style="border-radius: 8px; margin: auto"
          :src="editLessonLearnData.caseImage"
        ></v-img>
      </v-card>
    </v-dialog>
    <!-- cropimage -->
    <v-dialog
      v-model="dialogCrop"
      persistent
      width="1000px"
      height="800px"
      overflow="hidden"
    >
      <v-card class="rounded-lg" overflow="hidden">
        <v-card-title
          class="white--text pb-4"
          style="background-color: #a6cc39; font-size: 40px"
          >Crop Image</v-card-title
        >
        <v-card-text
          class="pt-12"
          style="height: 550px; padding-left: 4rem; padding-right: 4rem"
        >
          <vue-cropper
            ref="cropper"
            :img="option.img"
            :output-size="option.size"
            :output-type="option.outputType"
            :info="true"
            :full="option.full"
            :can-move="option.canMove"
            :can-move-box="option.canMoveBox"
            :fixed-box="option.fixedBox"
            :original="option.original"
            :auto-crop="option.autoCrop"
            :auto-crop-width="option.autoCropWidth"
            :auto-crop-height="option.autoCropHeight"
            :center-box="option.centerBox"
            :high="option.high"
          ></vue-cropper>
        </v-card-text>
        <v-card-actions class="mt-3 pb-4" style="margin-right: 50px">
          <v-spacer></v-spacer>
          <v-btn
            outlined
            class="text-capitalize font-style"
            text
            @click="CancelCrop()"
            >{{ $t("cancel") }}</v-btn
          >
          <v-btn
            class="text-capitalize font-style reset-btn"
            color="secondary"
            width="80px"
            @click="CropImage()"
            >{{ $t("submit") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Participant list -->
    <v-dialog width="500" v-model="listDialog" scrollable>
      <v-card>
        <v-card-title>
          <v-tabs hide-slider v-model="tabs" class="pt-3">
            <v-tab
              class="font-style text-capitalize"
              href="#tab-1"
              style="
                width: 165px;
                border-radius: 10px 0px 0px 10px;
                border: 1px solid #9fc437;
              "
              >{{ $t("user") }}</v-tab
            >
            <v-tab
              class="font-style text-capitalize"
              href="#tab-2"
              style="
                width: 165px;
                border-radius: 0px 10px 10px 0px;
                border: 1px solid #9fc437;
              "
              >{{ $t("group") }}</v-tab
            >
          </v-tabs>
        </v-card-title>
        <v-card-text style="height: 500px">
          <v-tabs-items v-model="tabs" class="mt-5">
            <v-tab-item value="tab-1">
              <v-data-table
                :items="users"
                item-key="userID"
                :loading="userLoading"
                loading-text="Loading... Please wait"
                v-model="editLessonLearnData.userSelected"
                show-select
                @toggle-select-all="SelectAllUser"
                :headers="userListHeader"
                hide-default-footer
                @page-count="userpageCount = $event"
                :page.sync="userpage"
                :no-data-text="$t('nodata')"
              >
                <template v-slot:no-data>
                  <p style="font-size: 16px">{{ $t("nodata") }}</p>
                </template>
              </v-data-table>
              <v-row no-gutters class="mt-1">
                <v-col cols="12" xs="12" sm="12" md="10" lg="10" xl="10" class="p-0">
                  <div class="d-flex text-left">
                    <v-pagination
                      circle
                      v-model="userpage"
                      class="pagination"
                      :length="userpageCount"
                    ></v-pagination>
                  </div>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item value="tab-2">
              <v-data-table
                :items="departments"
                item-key="groupID"
                @toggle-select-all="SelectAllDept"
                :loading="departmentLoading"
                loading-text="Loading... Please wait"
                v-model="editLessonLearnData.groupSelected"
                show-select
                :headers="departmentListHeader"
                hide-default-footer
                @page-count="deptpageCount = $event"
                :page.sync="deptpage"
                :no-data-text="$t('nodata')"
              >
                <template v-slot:no-data>
                  <p style="font-size: 16px">{{ $t("nodata") }}</p>
                </template>
              </v-data-table>
              <v-row no-gutters class="mt-1">
                <v-col cols="12" xs="12" sm="12" md="10" lg="10" xl="10" class="p-0">
                  <div class="d-flex text-left">
                    <v-pagination
                      circle
                      v-model="deptpage"
                      class="pagination"
                      :length="deptpageCount"
                    ></v-pagination>
                  </div>
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="mt-3 pb-4">
          <v-spacer></v-spacer>
          <v-btn
            class="text-capitalize font-style"
            text
            @click="CancelPermissionList()"
            >{{ $t("cancel") }}</v-btn
          >
          <v-btn
            class="text-capitalize font-style"
            color="primary"
            @click="savePermissionList()"
            >{{ $t("save") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Success -->
    <v-dialog v-model="successDialog" width="550">
      <v-card>
        <v-card-title
          style="font-size: 20px; color: #363636; height: 80px"
          class="justify-center"
        >
          <v-icon class="mr-5" style="color: #a6cc39"
            >mdi-checkbox-marked-circle</v-icon
          >
          {{ $t("updatelessonlearn") }}
        </v-card-title>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { VueCropper } from "vue-cropper";
import { mapGetters } from "vuex";
import * as moment from "moment/moment";
export default {
  components: {
    VueCropper,
  },
  props: {
    show: {
      type: Boolean,
      default: null,
    },
    fullName: String,
  },
  computed: {
    ...mapGetters([
      "editLessonLearnData",
      "showFirstTimeEditDataForLessonLearn",
    ]),
    dialog: {
      get() {
        return this.show;
      },
      set() {
        this.$emit("close");
      },
    },
    userListHeader() {
      return [
        {
          text: this.$t("name"),
          align: "left",
          value: "fullName",
          // width: "500px",
        },
      ];
    },
    departmentListHeader() {
      return [
        {
          text: this.$t("name"),
          align: "left",
          value: "groupName",
        },
      ];
    },
    selectedListUserHeader() {
      return [
        {
          text: this.$t("name"),
          align: "left",
          value: "fullName",
          width: "500px",
        },
        // {
        //   text: this.$t("viewpermission"),
        //   align: "center",
        //   value: "permission"
        // },
        {
          text: this.$t("request"),
          align: "center",
          value: "request",
          width: "165px",
        },
        // {
        //   text: this.$t("repeat"),
        //   align: "center",
        //   value: "times"
        // },
        {
          text: this.$t("expiredate"),
          align: "center",
          value: "perDay",
          width: "220px",
        },
        {
          text: this.$t("action"),
          align: "center",
          value: "index",
          width: "160px",
        },
      ];
    },
    selectedListDepartmentHeader() {
      return [
        {
          text: this.$t("name"),
          align: "center",
          value: "groupName",
        },
        {
          text: this.$t("viewpermission"),
          align: "center",
          value: "permission",
        },
        {
          text: this.$t("assign"),
          align: "center",
          value: "request",
          width: "150px",
        },
        // {
        //   text: this.$t("repeat"),
        //   align: "center",
        //   value: "times"
        // },
        {
          text: this.$t("expiredate"),
          align: "center",
          value: "perDay",
          width: "220px",
        },
        {
          text: this.$t("action"),
          align: "center",
          value: "index",
          width: "160px",
        },
      ];
    },
    editStartDate: {
      get() {
        if (this.editLessonLearnData.startContentDate)
          return this.editLessonLearnData.startContentDate.split("T")[0];
        else return false;
      },
      set(e) {
        this.editLessonLearnData.startContentDate = e;
      },
    },
    editEndDate: {
      get() {
        if (this.editLessonLearnData.startContentDate)
          return this.editLessonLearnData.endContentDate.split("T")[0];
        else return false;
      },
      set(e) {
        this.editLessonLearnData.endContentDate = e;
      },
    },
    titleRules() {
      return [(v) => !!v || "Title is required"];
    },
    wordContentRules() {
      return [(v) => !!v || "Word Content is required"];
    },
    checkSelected() {
      return this.editLessonLearnData;
    },
    isLink() {
      const urlRegex = /^(https?:\/\/(www\.)|(www\.))|(ftp|http(s)?:\/\/).+$/;
      let result;
      if (this.editLessonLearnData.link == null) {
        result = true;
      } else if (this.editLessonLearnData.link.length == 0) {
        result = true;
      } else {
        result = urlRegex.test(this.editLessonLearnData.link);
      }

      return result;
      // Regular expression to check if the input is a valid URL
      // const urlRegex = /^(ftp|http(s)?:\/\/)?(www\.)?[^ "]+$/;
      // const urlRegex = /^(https?:\/\/(www\.)|(www\.))|(ftp|http(s)?:\/\/).+$/;

      // Return true if the input matches the URL pattern, false otherwise
      // return urlRegex.test(this.editLessonLearnData.link);
    },
  },
  data: () => ({
    inbox_flag: false,
    pushNoti_flag: false,
    email_flag: false,
    line_flag: false,
    selectedRadio: null,
    notLink: false,
    showEditImgTool: false,
    createdate: moment(new Date().toISOString().substr(0, 10))
      .local()
      .format("DD MMM YYYY"),
    loading: false,
    rules: {
      required: (value) => !!value || "",
    },
    rulesDate: {
      // required: v => v.length > 11 || '',
      required: (v) => v.split("-").length > 2 || "",
    },
    selectedList: [],
    dialogCrop: false,
    previewimg: false,
    page: 1,
    pageCount: 0,
    userpage: 1,
    userpageCount: 0,
    deptpage: 1,
    deptpageCount: 0,
    option: {
      img: "",
      size: 1,
      full: false,
      outputType: "png",
      canMove: true,
      fixedBox: true,
      original: false,
      canMoveBox: false,
      autoCrop: true,
      autoCropWidth: 800,
      autoCropHeight: 450,
      centerBox: false,
      high: true,
    },
    valid: false,
    successDialog: false,
    LessonLearnData: {
      caseTitle: "",
      caseDescription: "",
      wordContent: "",
      caseImage: "",
      startDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      endDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      companyId: localStorage.getItem("companyID"),
      file: null,
      fileName: "",
      fileUrl: "",
      allView: false,
      link: "",
      PDFUrl: "",
      pdffilename: "",
      PDFButtonDisable: false,
    },
    isUser: false,
    listDialog: false,
    startDateMenu: false,
    endDateMenu: false,
    userSelected: [],
    departmentSelected: [],
    tabs: "tab-1",
    users: [],
    departments: [],
    userLoading: true,
    departmentLoading: true,
    departmentdataList: [],
    userdataList: [],
    userLength: 0,
    departmentLength: 0,
    allowedStartDates: (val) => val >= new Date().toISOString().substr(0, 10),
    fileError: false,
  }),
  mounted() {
    this.getUserData();
    this.getDepartment();
  },
  methods: {
    handleCheckboxChange() {
      if (this.email_flag) {
        // When checkbox is checked, set the default radio button value
        this.selectedRadio = 'thai';
      } else {
        // When checkbox is unchecked, clear the selected radio button
        this.selectedRadio = null;
      }
    },
    checkLinkType() {
      if (this.isLink || this.editLessonLearnData.link === "") {
        this.notLink = false;
      } else {
        this.notLink = true;
      }
    },
    checkdisabledata(filename) {
      if (filename != null && filename != "") {
        this.LessonLearnData.PDFButtonDisable = true;
      } else {
        this.LessonLearnData.PDFButtonDisable = false;
      }
    },
    editstartdateDis() {
      this.startDateMenu = false;
      if (this.editStartDate > this.editEndDate) {
        this.editEndDate = this.editStartDate;
      }
    },
    allowedEndDates(val) {
      return val >= this.editStartDate;
    },
    allowedPerday(val) {
      return val <= this.editEndDate && val >= this.editStartDate;
    },
    getSelectedList() {
      if (this.editLessonLearnData) {
        if (this.editLessonLearnData.isUserGroup == 1) {
          this.departmentLength = this.editLessonLearnData.groupSelected.length;
          this.selectedList = this.editLessonLearnData.groupSelected.map(
            (v, i) => ({
              ...v,
              fullName: v.groupName,
              userPermissionID: v.groupID,
              dateStatus: this.checkOrgianlStatus(v.perDay),
              index: i,
            })
          );
          return this.selectedList;
        } else {
          this.userLength = this.editLessonLearnData.userSelected.length;
          this.selectedList = this.editLessonLearnData.userSelected.map(
            (v, i) => ({
              ...v,
              userPermissionID: v.userID,
              dateStatus: this.checkOrgianlStatus(v.perDay),
              index: i,
            })
          );
          return this.selectedList;
        }
      }
      return [];
    },
    CancelPermissionList() {
      this.listDialog = false;
      this.userdataList = [];
      this.departmentdataList = [];
    },
    DeletefromUser(i) {
      this.selectedList.splice(
        this.selectedList.findIndex((item) => item.index === i.index),
        1
      );
    },
    async savePermissionList() {
      let user = [];
      let department = [];
      if (this.tabs == "tab-1") {
        for (const element of this.editLessonLearnData.userSelected) {
          const found = this.selectedList.find(
            (c) => c.userID == element.userID
          );
          if (found == undefined) {
            const filteruserdata = this.userdataList.find(
              (d) => d.employeeID == element.userID
            );
            if (filteruserdata == undefined) {
              user.push({
                employeeID: element.userID,
                fullName: element.fullName,
                isCheck: true,
                isUser: true,
                perDay: this.perDay,
                //permission: false,
                request: false,
                dateStatus: "Date Picker",
                times: 1,
                userPermissionID: element.userID,
                index: this.userLength + 1,
              });
              this.userLength = this.userLength + 1;
            } else {
              user.push({
                employeeID: filteruserdata.employeeID,
                fullName: filteruserdata.fullName,
                isCheck: filteruserdata.isCheck,
                isUser: filteruserdata.isUser,
                perDay: filteruserdata.perDay,
                // permission: filteruserdata.permission,
                request: filteruserdata.request,
                dateStatus: filteruserdata.dateStatus,
                times: filteruserdata.times,
                userPermissionID: filteruserdata.userPermissionID,
                index: filteruserdata.index,
              });
            }
          } else {
            user.push({
              employeeID: found.userID,
              fullName: found.fullName,
              isCheck: true,
              isUser: found.isUser,
              perDay: found.perDay,
              // permission: found.permission,
              request: found.request,
              dateStatus: found.dateStatus,
              times: found.times,
              userPermissionID: found.userID,
              index: found.index,
            });
          }
        }
        this.selectedList = user;
        this.userdataList = user;

        this.$store.commit("changeLessonLearnGroup", 2);
      } else {
        for (
          let i = 0;
          i < this.editLessonLearnData.groupSelected.length;
          i++
        ) {
          const found1 = this.selectedList.find(
            (c) =>
              c.groupID == this.editLessonLearnData.groupSelected[i].groupID
          );
          if (found1 == undefined) {
            const filterdepartdata = this.departmentdataList.find(
              (c) =>
                c.employeeID ==
                this.editLessonLearnData.groupSelected[i].groupID
            );
            if (filterdepartdata == undefined) {
              department.push({
                employeeID: this.editLessonLearnData.groupSelected[i].groupID,
                fullName: this.editLessonLearnData.groupSelected[i].groupName,
                isCheck: true,
                isUser: false,
                perDay: this.editLessonLearnData.groupSelected[i].perDay,
                // permission: false,
                request: false,
                dateStatus: "Date Picker",
                times: 1,
                userPermissionID:
                  this.editLessonLearnData.groupSelected[i].groupID,
                index: i,
              });
            } else {
              department.push({
                employeeID: filterdepartdata.employeeID,
                fullName: filterdepartdata.fullName,
                isCheck: filterdepartdata.isCheck,
                isUser: filterdepartdata.isUser,
                perDay: filterdepartdata.perDay,
                // permission: filterdepartdata.permission,
                request: filterdepartdata.request,
                dateStatus: filterdepartdata.dateStatus,
                times: filterdepartdata.times,
                userPermissionID: filterdepartdata.userPermissionID,
                index: filterdepartdata.index,
              });
            }
          } else {
            department.push({
              employeeID: found1.groupID,
              fullName: found1.groupName,
              isCheck: true,
              isUser: found1.isUser,
              perDay: found1.perDay,
              // permission: found1.permission,
              request: found1.request,
              dateStatus: found1.dateStatus,
              times: found1.times,
              userPermissionID: found1.groupID,
              index: found1.index,
            });
          }
        }
        this.selectedList = [];
        this.selectedList = department;
        this.departmentdataList = department;
        this.$store.commit("changeLessonLearnGroup", 1);
      }
      this.selectedList =
        this.editLessonLearnData.isUserGroup == 2 ? user : department;
      this.listDialog = false;
    },
    SelectAllUser() {
      if (this.editLessonLearnData.userSelected == undefined) {
        this.editLessonLearnData.userSelected = this.users;
      } else if (this.editLessonLearnData.userSelected.length == 0) {
        this.editLessonLearnData.userSelected = this.users;
      } else {
        this.editLessonLearnData.userSelected = [];
      }
    },
    SelectAllDept() {
      if (this.editLessonLearnData.groupSelected == undefined) {
        this.editLessonLearnData.groupSelected = this.departments;
      } else if (this.editLessonLearnData.groupSelected.length == 0) {
        this.editLessonLearnData.groupSelected = this.departments;
      } else {
        this.editLessonLearnData.groupSelected = [];
      }
    },
    dropImg(e) {
      let file = e.dataTransfer.files[0];
      if (!/(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(file.name)) {
        alert("Please choose image!");
        return false;
      }
      this.LessonLearnData.fileName = file.name;
      let reader = new FileReader();
      reader.onload = (f) => {
        // f.target.result contains the base64 encoding of the image
        let src;
        if (typeof f.target.result === "object") {
          src = window.URL.createObjectURL(new Blob([f.target.result]));
        } else {
          src = f.target.result;
        }
        this.option.img = src;
        this.dialogCrop = true;
      };
      reader.readAsArrayBuffer(file);
    },
    uploadImg(e, num) {
      let file = e.target.files[0];
      if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
        alert("Please choose image!");
        return false;
      }
      this.LessonLearnData.fileName = file.name;
      let reader = new FileReader();
      reader.onload = (f) => {
        let data;
        if (typeof f.target.result === "object") {
          data = window.URL.createObjectURL(new Blob([f.target.result]));
        } else {
          data = f.target.result;
        }
        if (num === 1) {
          this.option.img = data;
          this.dialogCrop = true;
        }
        this.$refs.file.value = '';
      };
      reader.readAsArrayBuffer(file);
    },
    CancelCrop() {
      this.dialogCrop = false;
    },
    CancelPreview() {
      this.previewimg = false;
    },
    CropImage() {
      this.$refs.cropper.getCropData((data) => {
        this.getFile(data);
        this.dialogCrop = false;
      });
    },
    openList() {
      let temp = [];
      this.tabs =
        this.editLessonLearnData.isUserGroup == "2" ? "tab-1" : "tab-2";
      this.listDialog = true;
      if (this.editLessonLearnData.isUserGroup == 2) {
        if (this.selectedList.length > 0) {
          for (let i of this.selectedList) {
            const found = this.users.find(
              (c) => c.userID == i.userPermissionID
            );
            if (found != undefined) {
              temp.push(found);
            }
          }
        }
        this.editLessonLearnData.userSelected = temp;
      } else {
        if (this.selectedList.length > 0) {
          for (let i of this.selectedList) {
            const found = this.departments.find(
              (c) => c.groupID == i.userPermissionID
            );
            if (found != undefined) {
              temp.push(found);
            }
          }
        }
        this.editLessonLearnData.groupSelected = temp;
      }
    },
    saveList() {
      if (this.tabs == "tab-1") {
        this.$store.commit("changeLessonLearnGroup", 2);
        this.editLessonLearnData.groupSelected = [];
      } else {
        this.$store.commit("changeLessonLearnGroup", 1);
        this.editLessonLearnData.userSelected = [];
      }
      this.listDialog = false;
    },
    checkOrgianlStatus(item) {
      if (item) {
        if (item.includes("T")) {
          return item.split("T")[0];
        } else {
          return item;
        }
      } else {
        return "Date Picker";
      }
    },
    // checkStatus(item) {
    //   if (item.date.length == 0) {
    //     return "Date Picker";
    //   } else if (item.date.length == 1) {
    //     return "Selected Date";
    //   } else {
    //     return "Selected Dates";
    //   }
    // },
    async getUserData() {
      this.userLoading = true;
      await this.$axios
        .get(
          `${this.web_urlV6}EmployeeEXT/GetEmployeeExtAllV4?id=` +
            localStorage.getItem("companyID")
        )
        .then((res) => {
          this.users = res.data.data.map((v) => ({
            ...v,
            //permission: false,
            request: false,
            repeat: 0,
            menu: false,
            date: [],
            dateStatus: "Date Picker",
            //   index:i,
          }));
        })
        .catch((err) => {
          alert(err);
        });
      this.userLoading = false;
    },

    async getDepartment() {
      this.departmentLoading = true;
      await this.$axios
        .get(
          `${this.web_url}Group/GetGroupALL?id=` +
            localStorage.getItem("companyID")
        )
        .then((res) => {
          this.departments = res.data.data.map((v) => ({
            ...v,
            // permission: false,
            request: false,
            repeat: 0,
            menu: false,
            date: [],
            dateStatus: "Date Picker",
            //  index:i,
          }));
        })
        .catch((err) => {
          alert(err);
        });
      this.departmentLoading = false;
    },

    getFile(e) {
      this.LessonLearnData.fileUrl = e;
      this.LessonLearnData.file = e;
      this.editLessonLearnData.caseImage = e;
    },
    async getpdfFile(e) {
      let file = e.target.files[0];
      if (/\.pdf$/.test(e.target.value)) {
        this.editLessonLearnData.pdFfilename = file.name;
        this.LessonLearnData.PDFUrl = e;
        this.LessonLearnData.PDFButtonDisable = true;
      } else {
        alert("Choose PDF files only, please re-select!");
        return false;
      }
    },
    DeletePDFfile() {
      this.editLessonLearnData.pdFfilename = "";
      this.LessonLearnData.PDFUrl = "";
      this.LessonLearnData.PDFButtonDisable = false;
    },
    imageTobase64(fileObject) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.LessonLearnData.file = e.target.result;
      };
      reader.readAsDataURL(fileObject);
    },
    async submit() {
      if (this.$refs.form.validate() && this.notLink === false) {
        this.loading = true;
        let permissionList = [];
        if (this.editLessonLearnData.isUserGroup == 2) {
          for (const element of this.selectedList) {
            permissionList.push({
              fullName: element.fullName,
              isUser: true,
              isComplete: element.isComplete,
              perDay: element.perDay,
              // permission: this.selectedList[i].permission,
              request: element.request,
              selectedDate: element.dateStatus ? element.dateStatus : "",
              times: 1, //parseInt(this.selectedList[i].times),
              userPermissionID: element.userPermissionID,
            });
          }
        } else {
          for (const element of this.selectedList) {
            permissionList.push({
              employeeID: element.employeeID,
              fullName: element.groupName,
              isComplete: element.isComplete,
              isUser: false,
              perDay: element.perDay,
              // permission: this.selectedList[i].permission,
              request: element.request,
              selectedDate: element.dateStatus ? element.dateStatus : "",
              times: 1, //parseInt(this.selectedList[i].times),
              userPermissionID: element.userPermissionID,
            });
          }
        }
        if (this.LessonLearnData.PDFUrl != "") {
          let formData = new FormData();
          formData.append("file", this.LessonLearnData.PDFUrl.target.files[0]);
          const res = await this.$axios.post(
            `${this.web_url}File/UploadPDFFile`,
            formData
          );
          this.LessonLearnData.PDFUrl = res.data.data;
          this.editLessonLearnData.pdffilename =
            this.LessonLearnData.pdffilename;
        }
        let base64Res = { data: null };
        if (this.LessonLearnData.file) {
          base64Res = await this.$axios.post(
            `${this.web_url}File/UploadFileStringBase`,
            {
              base64: this.LessonLearnData.file,
              fileName: this.LessonLearnData.fileName,
            }
          );
        }

        const userdata = JSON.parse(
          localStorage.getItem("vivek_authenticated_user_data")
        );
        const memberid = userdata.memberId;
        const data = {
          id: this.editLessonLearnData.id,
          permissionData: permissionList,
          wordContent: this.editLessonLearnData.wordContent,
          caseTitle: this.editLessonLearnData.caseTitle,
          endContentDate: this.editLessonLearnData.endContentDate.split("T")[0],
          isUserGroup: this.editLessonLearnData.isUserGroup,
          caseImage: this.LessonLearnData.file
            ? base64Res.data
            : this.editLessonLearnData.caseImage,
          imgBase64: this.LessonLearnData.file
            ? this.LessonLearnData.file
            : this.editLessonLearnData.thumbnail,
          startContentDate:
            this.editLessonLearnData.startContentDate.split("T")[0],
          companyId: localStorage.getItem("companyID"),
          caseDescription: this.editLessonLearnData.caseDescription,
          allView:
            this.editLessonLearnData.allView == null
              ? false
              : this.editLessonLearnData.allView,
          link: this.editLessonLearnData.link,
          // imgBase64:this.LessonLearnData.file,
          updateBy: memberid,
          pdfUrl: this.LessonLearnData.PDFUrl,
          pdfFilename: this.editLessonLearnData.pdFfilename,
          inboxFlag: this.inbox_flag,
          emailFlag: this.email_flag,
          emailLanguage: this.selectedRadio,
          pushNotiFlag: this.pushNoti_flag,
          lineFlag: this.line_flag,
        };

        await this.$axios.post(
          `${this.web_url}CaseStudies/UpdateCaseStudy`,
          data
        ).then(function (res) {
          console.log(res.data.status);
        })
        this.loading = false;
        this.editLessonLearnData = {
          caseTitle: "",
          caseDescription: "",
          startDate: new Date(
            Date.now() - new Date().getTimezoneOffset() * 60000
          )
            .toISOString()
            .substr(0, 10),
          endDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
            .toISOString()
            .substr(0, 10),
          wordContent: "",
          file: null,
          fileName: "",
          fileUrl: "",
        };
        this.inbox_flag = false;
        this.email_flag = false;
        this.pushNoti_flag = false;
        this.line_flag = false;
        this.$refs.file.value = null;
        this.getUserData();
        this.userdataList = [];
        this.departmentdataList = [];
        this.$emit("confirm");
        this.successDialog = true;
        this.$refs.form.reset();
        this.DeletePDFfile();
        this.CancelPermissionList();
      } else {
        alert("Incomplete information Please enter again!");
      }
      this.loading = false;
    },
  },
  watch: {
    checkSelected(val, oldVal) {
      if ((val, oldVal)) {
        this.getSelectedList();
      }
    },
    userSelected(val) {
      if (val.length != 0) {
        this.departmentSelected = [];
        this.isUser = true;
        this.$store.commit("removeFirstTimeEditDataForLessonLearn");
      }
    },
    departmentSelected(val) {
      if (val.length != 0) {
        this.userSelected = [];
        this.isUser = false;
        this.$store.commit("removeFirstTimeEditDataForLessonLearn");
      }
    },
  },
};
</script>
<style scoped>
.radio-group {
  display: flex;
  align-items: center;
}
.radiobutton{
  margin-top: -10px;
}
.radio-wrapper {
  position: relative;
  width: 22px;
  height: 22px;
}

.radio-placeholder,
.radio-button {
  position: absolute;
  top: 2px;
 

left: 0;
  width: 20px;
  height: 20px;
  border-radius: 50%;
}

.radio-placeholder {
  background-color:#424242;
  opacity: 0.1;
  pointer-events: none; /* Prevent interaction */
}
.customcardnoti {
  width: 98%;
  margin-left: 10px;
  background-color: #e0e0e0;
}
::v-deep .v-dialog {
  border-radius: 16px !important;
}
::v-deep .v-text-field__slot {
  font-size: 16px !important;
}
.font-style {
  font-size: 16px;
  color: #4d4f5c;
}
.btnfont-style {
  font-size: 16px;
  border-radius: 8px;
}
::v-deep .v-input__slot {
  border-radius: 10px !important;
}
::v-deep .lesson-table tr:nth-child(even) {
  background: #e0e0e0;
}
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  font-size: 17px !important;
  color: #47484b !important;
  background-color: #e0e0e0 !important;
  opacity: 1;
}
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td {
  font-size: 16px !important;
  color: #47484b !important;
  opacity: 1;
}
::v-deep .accent {
  background-color: #a6cc39 !important;
}
::v-deep .v-tab--active {
  background-color: #a6cc39 !important;
  color: #ffffff !important;
}
::v-deep .v-simple-checkbox .v-icon {
  color: #a6cc39 !important;
}
.loading-circle {
  position: fixed;
  z-index: 5;
  right: 50%;
  bottom: 50%;
  transform: translate(-50%, -50%);
}
::v-deep .pagination .primary {
  background-color: #a6cc39 !important;
  color: #ffffff !important;
  /* opacity: 1; */
}

::v-deep .accent--text {
  color: #a6cc39 !important;
}
::v-deep .primary--text {
  color: #a6cc39 !important;
  border-color: #a6cc39 !important;
}
::v-deep .primary {
  background-color: #a6cc39 !important;
  border-color: #a6cc39 !important;
}
::v-deep .v-simple-checkbox .mdi-checkbox-blank-outline {
  color: #c0c0c0 !important;
}
::v-deep .v-simple-checkbox .mdi-checkbox-marked {
  color: #a6cc39 !important;
}
::v-deep .v-simple-checkbox .mdi-minus-box {
  color: #a6cc39 !important;
}
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
</style>

<style>
.v-text-field__details {
  display: none !important;
}
</style>
